import { render, staticRenderFns } from "./OverviewFixedCall.vue?vue&type=template&id=6808b73f"
import script from "./OverviewFixedCall.vue?vue&type=script&lang=js"
export * from "./OverviewFixedCall.vue?vue&type=script&lang=js"
import style0 from "./OverviewFixedCall.vue?vue&type=style&index=0&id=6808b73f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports